import dayjs from "dayjs";

export function parseFormDataTextToJsonString(text) {
    if (!text.includes("form-data")) {
        return JSON.stringify(text);
    } else {
        let formDataStr = text.split("form-data; name=");
        let objectArray = [];
        formDataStr.forEach(subString => {
            const data = subString.substring(subString.indexOf("\\"), subString.indexOf('--'))
                .replaceAll("\r\n\r\n", ":")
                .replaceAll("\r\n", "");
            objectArray.push(data)
        })
        return objectArray.join(' ');
    }
}

export const formatdate = (timestamp) => {
    let d = timestamp ? dayjs(timestamp * 1000).utcOffset(180).format('YYYY-MM-DD HH:mm:ss') : null
    return d;
}


export const domainAlias = window._gamesConfig.reduce((result, game) => {
    result[game.hostname] = game.code;
    return result;
}, {});

export const domainConfig = window._gamesConfig.reduce((result, game) => {
    result[game.hostname] = game;
    return result;
}, {});

export const configs = window._gamesConfig.reduce((result, game) => {
    const config = {
        baseUrl: game.baseUrl,
        prodUrl: game.prodUrl,
        abTestUrl: game.abTestUrl,
        abTestProdUrl: game.abTestProdUrl,
        title: game.title,
        code: game.code
    };

    if (game.calendarUrl) config.calendarUrl = game.calendarUrl;
    if (game.calendarGameUrl) config.calendarGameUrl = game.calendarGameUrl;
    if (game.timelineMode !== undefined) config.timelineMode = game.timelineMode;

    config.msal = {
        auth: {
            authority: game.msalConfig.authority,
            clientId: game.msalConfig.clientId,
            redirectUri: document.location.host === 'localhost:3000'
                ? 'http://localhost:3000/'
                : `https://${game.hostname}/`
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: game.msalConfig.storeAuthStateInCookie
        }
    };

    if (game.msalConfig.tokenRenewalOffsetSeconds) {
        config.msal.system = {
            tokenRenewalOffsetSeconds: game.msalConfig.tokenRenewalOffsetSeconds
        };
    }

    result[game.code] = config;
    return result;
}, {});

export function getDomainAlias() {
    let h = window.location.hostname;
    if (!domainAlias.hasOwnProperty(h)) {
        return 'local';
    }
    return domainAlias[h];
}

//
// export const configs = {
//     "prod": {
//         title: 'prod',
//         baseUrl: "https://cm-push.belka-games.com/nutifier",
//         msal: {
//             auth: {
//                 authority: 'https://login.microsoftonline.com/3ac24b86-0088-49b2-98d0-0acf6e8b1a6f/',
//                 clientId: 'a372c94c-5c3d-4ad8-ba45-559eed332967',
//                 redirectUri: 'https://cm-push.belka-games.com/'
//             },
//             cache: {
//                 cacheLocation: "localStorage",
//                 storeAuthStateInCookie: false
//             }
//         }
//     },
//     "stage": {
//         title: 'staging',
//         baseUrl: "https://cm-nutifier.stage.belka-games.com/nutifier",
//         msal: {
//             auth: {
//                 authority: 'https://login.microsoftonline.com/3ac24b86-0088-49b2-98d0-0acf6e8b1a6f/',
//                 clientId: 'a372c94c-5c3d-4ad8-ba45-559eed332967',
//                 redirectUri: 'https://push.stage.belka-games.com/'
//             },
//             cache: {
//                 cacheLocation: "localStorage",
//                 storeAuthStateInCookie: false
//             }
//         }
//     },
//     "local": {
//         title: 'staging',
//         baseUrl: "/nutifier",
//         //baseUrl: "https://cm-nutifier.stage.belka-games.com/nutifier/",
//
//         msal: {
//             auth: {
//                 authority: 'https://login.microsoftonline.com/3ac24b86-0088-49b2-98d0-0acf6e8b1a6f/',
//                 clientId: 'e760f6ea-1fc1-4917-ae13-40ce42f28a22',
//                 redirectUri: document.location.host=='localhost:3000'?'http://localhost:3000/':'https://mephisto-cross.stage.belka-games.com/'
//             },
//             cache: {
//                 cacheLocation: "localStorage",
//                 storeAuthStateInCookie: false
//             }
//         }
//     },
// }
